export default [
  {
    name: 'google-feed',
    component: 'google-feed-form',
    title: 'google_shopping_feed_title',
  },
];
